/**
 * WEB前端工具库
 * Created by Mi on 2019/07/25.
 */

'use strict';

var Utils = {
  /**
   * 判断是否对象，并且为非空和非{}
   * @param  {number|string|array...} a 任何参数
   * @return {boolean}
   */
  isObjectNotEmpty: function(a) {
    if (typeof a === 'object' && !(a instanceof Array)) {
      for (var i in a) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  },
};

module.exports = Utils;
